import QuantityProduct from './QuantityProduct'

class DigitalRetouchedFurnishingPhotoProduct extends QuantityProduct {}

export default DigitalRetouchedFurnishingPhotoProduct
